(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dx-anadir"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dx-anadir')) {
    customElements.define(
      'dx-anadir',
      class extends HTMLElement {
        connectedCallback() {
          this.boton = this.querySelector('.dx-anadir__boton');
          this.estado = this.querySelector('[data-dx-estado]');
          /* Foto de la tarjeta de la portada: cambia con el color elegido */
          this.foto = this.closest('.dx-prod')?.querySelector('.dx-prod__img img');
          if (this.foto) {
            this.fotoInicial = { src: this.foto.src, srcset: this.foto.srcset };
            this.colorInicial = this.querySelector('.dx-anadir__color[aria-checked="true"]');
          }
          this.addEventListener('click', this.alPulsar);
        }

        cambiarFoto(color) {
          if (!this.foto) return;
          const nueva = color === this.colorInicial || !color.dataset.img
            ? this.fotoInicial
            : { src: color.dataset.img, srcset: color.dataset.srcset };
          if (this.foto.src === nueva.src) return;
          const poner = () => {
            this.foto.srcset = nueva.srcset;
            this.foto.src = nueva.src;
          };
          if (!this.foto.animate || !document.documentElement.classList.contains('dx-anim')) return poner();
          const precarga = new Image();
          precarga.srcset = nueva.srcset;
          precarga.sizes = this.foto.sizes;
          precarga.src = nueva.src;
          precarga.decode().catch(() => {}).then(() => {
            poner();
            this.foto.animate([{ opacity: 0.4 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
          });
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.alPulsar);
        }

        alPulsar = (e) => {
          const color = e.target.closest('.dx-anadir__color');
          if (color && !color.disabled) {
            this.querySelectorAll('.dx-anadir__color').forEach((c) => c.setAttribute('aria-checked', String(c === color)));
            this.boton.dataset.variante = color.dataset.variante;
            this.cambiarFoto(color);
            return;
          }
          if (e.target.closest('.dx-anadir__boton')) this.anadir();
        };

        async anadir() {
          if (this.classList.contains('is-cargando')) return;
          this.classList.add('is-cargando');
          const variante = this.boton.dataset.variante;
          try {
            if (window.Shopify?.actions?.updateCart) {
              const r = await window.Shopify.actions.updateCart({ lines: [{ merchandiseId: variante, quantity: 1 }] });
              if (r?.userErrors?.length) throw new Error(r.userErrors[0].message);
            } else {
              const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }] }),
              });
              if (!r.ok) throw new Error((await r.json()).description);
              window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
              return;
            }
            this.volar();
            this.estado.textContent = 'Añadido al carrito';
            this.classList.add('is-ok');
            clearTimeout(this.temporizador);
            this.temporizador = setTimeout(() => this.classList.remove('is-ok'), 2000);
          } catch (error) {
            this.estado.textContent = `No se ha podido añadir: ${error.message || 'inténtalo otra vez'}`;
          } finally {
            this.classList.remove('is-cargando');
          }
        }

        /* Un punto lima sale del botón y cae en el icono del carrito */
        volar() {
          if (!document.documentElement.classList.contains('dx-anim')) return;
          const destino = document.querySelector('cart-icon, .header-actions__cart-icon, a[href$="/cart"]');
          if (!destino || !this.boton.animate) return;
          const a = this.boton.getBoundingClientRect();
          const b = destino.getBoundingClientRect();
          const punto = document.createElement('span');
          punto.className = 'dx-vuelo';
          document.body.append(punto);
          const x0 = a.left + a.width / 2;
          const y0 = a.top + a.height / 2;
          const x1 = b.left + b.width / 2;
          const y1 = b.top + b.height / 2;
          punto
            .animate(
              [
                { transform: `translate(${x0}px, ${y0}px) scale(1)` },
                { transform: `translate(${(x0 + x1) / 2}px, ${Math.min(y0, y1) - 120}px) scale(1.4) rotate(90deg)`, offset: 0.5 },
                { transform: `translate(${x1}px, ${y1}px) scale(0.4) rotate(180deg)` },
              ],
              { duration: 700, easing: 'cubic-bezier(0.5, 0, 0.75, 0)' }
            )
            .finished.finally(() => {
              punto.remove();
              destino.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], {
                duration: 350,
                easing: 'cubic-bezier(0.23, 1, 0.32, 1)',
              });
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dx-video-alterno"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dx-video-alterno')) {
    customElements.define(
      'dx-video-alterno',
      class extends HTMLElement {
        connectedCallback() {
          this.videos = [...this.querySelectorAll('video')];
          if (!this.videos.length) return;

          this.actual = 0;
          this.enPantalla = true;
          this.videos.forEach((video, i) => {
            video.muted = true;
            video.addEventListener('ended', () => this.siguiente(i));
          });

          /* Con movimiento reducido no hay autoplay: se queda el póster del primero */
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.videos.forEach((video) => {
              video.autoplay = false;
              video.pause();
            });
            return;
          }

          /* El segundo empieza a cargar en serio cuando el primero ya está en marcha */
          this.videos[0].addEventListener(
            'playing',
            () => this.videos.slice(1).forEach((video) => (video.preload = 'auto')),
            { once: true }
          );

          this.observer = new IntersectionObserver(
            ([entrada]) => {
              this.enPantalla = entrada.isIntersecting;
              const video = this.videos[this.actual];
              if (this.enPantalla) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            },
            { threshold: 0.25 }
          );
          this.observer.observe(this);
        }

        siguiente(i) {
          if (i !== this.actual) return;
          const anterior = this.videos[i];
          this.actual = (i + 1) % this.videos.length;
          const proximo = this.videos[this.actual];

          /* Un solo vídeo: vuelve a empezar */
          if (proximo === anterior) {
            anterior.currentTime = 0;
            if (this.enPantalla) anterior.play().catch(() => {});
            return;
          }

          /* El anterior se queda en su último fotograma hasta que el siguiente pinta: sin parpadeo */
          const mostrar = () => {
            if (this.videos[this.actual] !== proximo) return;
            proximo.classList.add('is-activo');
            anterior.classList.remove('is-activo');
          };
          proximo.currentTime = 0;
          proximo.addEventListener('playing', mostrar, { once: true });
          if (this.enPantalla) {
            proximo.play().catch(mostrar);
          } else {
            mostrar();
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dx-video-vertical"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dx-video')) {
    customElements.define(
      'dx-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.boton = this.querySelector('.dx-video__sonido');
          if (!this.video) return;

          this.video.muted = true;
          this.boton?.addEventListener('click', () => {
            this.video.muted = !this.video.muted;
            this.boton.setAttribute('aria-pressed', String(!this.video.muted));
            if (this.video.paused) this.video.play().catch(() => {});
          });

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.video.controls = true;
            this.boton?.remove();
            return;
          }

          this.observer = new IntersectionObserver(
            ([entrada]) => {
              if (entrada.isIntersecting) {
                this.video.play().catch(() => {});
              } else {
                this.video.pause();
              }
            },
            { threshold: 0.4 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
